const MONTHS = [1, 2, 3];
const SEQUENCE = [...Array(5000).keys()];
const COMPONENTS = {
  butterFat: {
    1: [],
    2: [],
    3: [],
  },
  otherSolids: {
    1: [],
    2: [],
    3: [],
  },
  nonfatSolids: {
    1: [],
    2: [],
    3: [],
  },
  protein: {
    1: [],
    2: [],
    3: [],
  },
};
const COMPONENT_LIST = [...Object.keys(COMPONENTS)];

const SUBCOMPONENTS = {
  butter: {
    1: [],
    2: [],
    3: [],
  },
  cheese: {
    1: [],
    2: [],
    3: [],
  },
  dryWhey: {
    1: [],
    2: [],
    3: [],
  },
  nonfatDryMilk: {
    1: [],
    2: [],
    3: [],
  },
};
const SUBCOMPONENT_LIST = [...Object.keys(SUBCOMPONENTS)];
const COMPONENT_FACTORS = ['priceDraw', 'sigma', 'expectedPrice'];

module.exports = {
  COMPONENTS,
  COMPONENT_LIST,
  COMPONENT_FACTORS,
  MONTHS,
  SEQUENCE,
  SUBCOMPONENTS,
  SUBCOMPONENT_LIST,
};
